module.exports = __webpack_public_path__ + "media/images/categories/4-e9072f79fb8dd0db478ef0a3be14bc56.png";